import { render, staticRenderFns } from "./HistoryLimit.vue?vue&type=template&id=31d8badb&scoped=true&"
import script from "./HistoryLimit.vue?vue&type=script&lang=js&"
export * from "./HistoryLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d8badb",
  null
  
)

export default component.exports